import React from "react";
import { useTranslation } from "react-i18next";
import { UseCases } from "@planzone/core";
import {
  useAuthentication,
  useCreateCalendarExportLink,
  useRetrieveCalendarExportLinks,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";
import { useMessage } from "@components/useMessage";
import { events } from "@planzone/events";
import { Safeguard } from "@scenes/safeguard";
import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";
import { useModal } from "@root/client/modal";

function Export(props: Props) {
  const { pushView } = useModal();
  const { t } = useTranslation();
  const { account } = useAuthentication();
  const { planzone } = useRetrieveCurrentPlanzone();
  const {
    isRequestPending: isCreateRequestPending,
    isRequestSuccess: isCreateRequestSuccess,
    createCalendarExportLink,
  } = useCreateCalendarExportLink();
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    links,
    retrieveCalendarExportLinks,
  } = useRetrieveCalendarExportLinks();
  const link = links[0];

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveCalendarExportLinks(account.resource);
  }, []);

  useMessage((message) => {
    if (message.type === events.createCalendarExportLinkSucceeded) {
      pushView({
        key: UseCases.retrieveCalendarExportLinks,
        data: planzone,
      });
    }
  });
  return (
    <Safeguard useCases={[UseCases.createCalendarExportLink]}>
      {({ canCreateCalendarExportLink }) =>
        canCreateCalendarExportLink && (
          <div className={styles.export}>
            <Button
              type="submit"
              className={styles.exportButton}
              press={() => {
                !link
                  ? canCreateCalendarExportLink &&
                    !isCreateRequestPending &&
                    createCalendarExportLink({
                      planzone,
                      resource: account.resource,
                    })
                  : pushView({
                      key: UseCases.retrieveCalendarExportLinks,
                      data: planzone,
                    });
              }}
            >
              {t("calendarPage.exports.export")}
            </Button>
          </div>
        )
      }
    </Safeguard>
  );
}

export { Export };
